export const logoUrl = "https://assets.auxodev.dk/assets/39491458-c5e4-4280-8295-09ca3e3ec516/e1dc0508-6275-487b-8663-91e553176489.png";
export const heroBgUrl = "https://assets.auxodev.dk/assets/39491458-c5e4-4280-8295-09ca3e3ec516/c1d5f860-5a63-45a2-a251-e5177a9b5567.jpg";

export const companyData = {
  name: "Bust Byg & Renovering ApS",
  phone: "22 80 00 15",
  phoneRaw: "+4522800015",
  email: "kontakt@bustbyg.dk",
  address: "Ringstedvej 632A, 4100 Ringsted",
  addressMapUrl: "https://maps.google.com/?q=Ringstedvej+632A,+4100+Ringsted",
  tagline: "Renovering, VVS, tømrer- og murerarbejde udført med fokus på kvalitet og godt håndværk.",
  about: {
    title: "Om os",
    subtitle: "Kvalitet, ordentlighed og løsninger, der holder",
    paragraphs: [
      "Hos Bust Byg & Renovering ApS hjælper vi både private og erhverv med store og små byggeprojekter. Vi lægger stor vægt på det gode, solide håndværk og den tætte dialog med vores kunder.",
      "Vi tilbyder alt fra renoveringer og ombygninger til VVS-, tømrer- og murerarbejde. Vi lægger vægt på kvalitet, ordentlighed og løsninger, der holder. Vores mål er altid at levere et resultat, som både vi og vores kunder kan være stolte af."
    ],
    bullets: [
      "Fokus på høj kvalitet og godt håndværk",
      "Erfarne og faglærte håndværkere",
      "Tæt dialog og gennemsigtige aftaler",
      "Totalentreprise – vi koordinerer hele projektet",
      "Vi udfører alt inden for byggeri – undtagen el-arbejde"
    ]
  },
  services: [
    {
      id: "renovering",
      title: "Renoveringer",
      description: "Komplette renoveringsløsninger til bolig og erhverv. Vi forvandler slidte rammer til moderne og funktionelle rum.",
      icon: "Hammer"
    },
    {
      id: "vvs",
      title: "VVS",
      description: "Installation, reparation og vedligeholdelse af VVS-løsninger. Altid udført efter gældende regler og standarder.",
      icon: "Wrench"
    },
    {
      id: "toemrer",
      title: "Tømrerarbejde",
      description: "Alt inden for træarbejde, ombygninger og specialopgaver. Fra nye terrasser to tagkonstruktioner og spær.",
      icon: "Construction"
    },
    {
      id: "murer",
      title: "Murerarbejde",
      description: "Mureropgaver, facader, flisearbejde og reparationer. Vi sikrer et robust og æstetisk flot resultat.",
      icon: "Grid"
    },
    {
      id: "maler",
      title: "Malerarbejde",
      description: "Professionelt malerarbejde til både indendørs og udendørs projekter. Vi sikrer pæne og holdbare overflader med sans for detaljen.",
      icon: "Paintbrush"
    },
    {
      id: "totalentreprise",
      title: "Totalentreprise",
      description: "Vi hjælper med koordinering af hele projektet og samarbejder med relevante faggrupper. Vi udfører alt inden for byggeri – undtagen el-arbejde.",
      icon: "Briefcase"
    },
    {
      id: "handyman",
      title: "Handymanopgaver",
      description: "Mindre reparationer, montering af inventar, ophængning og diverse praktiske opgaver i boligen eller på kontoret. Hurtig og effektiv hjælp til det hele.",
      icon: "Settings"
    }
  ],
  seo: {
    title: "Bust Byg & Renovering ApS | Renovering, VVS, Tømrer & Murer i Ringsted",
    description: "Bust Byg & Renovering ApS udfører renoveringer, VVS-, tømrer- og murerarbejde i Ringsted og omegn. Kontakt os for et uforpligtende tilbud."
  }
};
